export function init() {
  // Make the go back button go to the last non-active breadcrumb link
  const goBackEl = document.querySelector(".js-go-back");
  const dropdownBodyEl = document.querySelector("#breadcrumbs-dropdown-body");

  if (!goBackEl) return;

  // if breadcrumb-dropdown-body exists, look for last link in it
  if (dropdownBodyEl) {
    goBackEl.href = dropdownBodyEl.lastElementChild.href;
  } else {
    const breadcrumbsEl = goBackEl.parentElement;
    const linksEl = breadcrumbsEl.querySelectorAll(".breadcrumb__link");

    if (linksEl.length < 2) return;

    const lastLinkEl = linksEl[linksEl.length - 2];
    goBackEl.href = lastLinkEl.href;
  }
}
